

  function addBannerCollection() {
    // Obtener el total de elementos en la lista
    let totalList = document.querySelectorAll('ul.product-grid li.pd-card').length;
    // Contar el total de banners
    let brCard = document.querySelectorAll('.grid-banner').length;
    
    // Función para obtener un número aleatorio
    function getRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    

    // Si no hay banners o totalList es menor a 3, agregar card1 al final
    if (brCard === 0 && totalList <= 3) {
      console.log(totalList)
      console.log("hay menos o igual a 3")
      const newItem = document.createElement('li');
      newItem.className = 'grid__item grid-banner';
      newItem.innerHTML = window.card_1;
      document.querySelector('ul.product-grid').appendChild(newItem);
    } 
    // Si totalList es mayor a 3 y menor a 9, agregar card1 en una posición aleatoria entre 2 y 5
    else if (totalList > 3 && totalList < 9) {
      console.log(totalList)
      console.log("hay mas de 3 y menos de 9")
      let randomNumber1 = getRandomNumber(2, 5);
      const newItemCard1 = document.createElement('li');
      newItemCard1.className = 'grid__item grid-banner';
      newItemCard1.innerHTML = window.card_1;
  
      const randomItem1 = document.querySelector(`ul.product-grid li:nth-child(${randomNumber1})`);
      if (randomItem1) {
        randomItem1.parentNode.insertBefore(newItemCard1, randomItem1.nextSibling);
      }
    } 
    // Si totalList es mayor a 9, agregar card1 en una posición aleatoria entre 2 y 5 y card2 entre 9 y 12
    else if (totalList > 9) {
      console.log(totalList)
      console.log("mas de 9")
      let randomNumber1 = getRandomNumber(2, 5);
      let randomNumber2 = getRandomNumber(9, 12);
  
      const newItemCard1 = document.createElement('li');
      newItemCard1.className = 'grid__item grid-banner';
      newItemCard1.innerHTML = window.card_1;
  
      const randomItem1 = document.querySelector(`ul.product-grid li:nth-child(${randomNumber1})`);
      if (randomItem1) {
        randomItem1.parentNode.insertBefore(newItemCard1, randomItem1.nextSibling);
      }
  
      const newItemCard2 = document.createElement('li');
      newItemCard2.className = 'grid__item grid-banner';
      newItemCard2.innerHTML = window.card_2;
  
      const randomItem2 = document.querySelector(`ul.product-grid li:nth-child(${randomNumber2})`);
      if (randomItem2) {
        randomItem2.parentNode.insertBefore(newItemCard2, randomItem2.nextSibling);
      }
    }
  }

  // Función para observar la lista de productos y ejecutar addBannerCollection
  // function observeProductList() {
  //   const productList = document.querySelector('ul.product-grid');
    
  //   // Solo si la lista de productos existe
  //   if (productList) {
  //     const observer = new MutationObserver(() => {
  //       addBannerCollection(); // Llama a la función cuando se detectan cambios en el DOM
  //     });

  //     observer.observe(productList, { childList: true, subtree: true }); // Observa cambios en los hijos de la lista
  //   }
  // }

  function debounce(func, delay) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }
  
  const debouncedAddBannerCollection = debounce(addBannerCollection, 500);
  
  // Se ejecuta al cargar el DOM
  // document.addEventListener('DOMContentLoaded', function() {
  //   setTimeout(debouncedAddBannerCollection, 1000);
  // });
  
  // Ejecutar addBannerCollection al cargar la ventana con un delay de 1 segundo
  window.addEventListener('load', function() {
    setTimeout(debouncedAddBannerCollection, 1000);
  });
  
  // Ejecutar addBannerCollection al resize la ventana con un delay de 1 segundo
  // window.addEventListener('resize', function() {
  //   setTimeout(debouncedAddBannerCollection);
  // });
  
  // Listener para clics en filtros específicos
  window.addEventListener('click', (event) => {
    if (event.target.classList.contains('gf-Checkbox') 
        || event.target.classList.contains('gf-label')
        || event.target.classList.contains('gf-clear') 
        || event.target.classList.contains('sort_by')) {
      setTimeout(debouncedAddBannerCollection, 1000);
    }
  });

  window.addEventListener('click', (event) => {
    if (event.target.classList.contains('facet-filters__sort') 
        || event.target.classList.contains('gf-label')
        || event.target.classList.contains('gf-clear')) {
      setTimeout(debouncedAddBannerCollection, 1000);
    }
  });


  // Función con async / await //

  // document.addEventListener('DOMContentLoaded', function () {
  //   console.log("Evento DOMContentLoaded detectado");
  //   setTimeout(() => {
  //     console.log("Llamando a addBannerCollection desde DOMContentLoaded");
  //     addBannerCollection();
  //   }, 1000);
  // });
  
  // window.addEventListener('resize', function () {
  //   console.log("Evento resize detectado");
  //   setTimeout(() => {
  //     console.log("Llamando a addBannerCollection desde resize");
  //     addBannerCollection();
  //   }, 2000);
  // });
  
  // document.addEventListener('click', (event) => {
  //   if (
  //     event.target.classList.contains('gf-Checkbox') ||
  //     event.target.classList.contains('gf-label') ||
  //     event.target.classList.contains('gf-clear') ||
  //     event.target.classList.contains('sort_by')
  //   ) {
  //     console.log("Evento click detectado en filtros");
  //     setTimeout(() => {
  //       console.log("Llamando a addBannerCollection desde click");
  //       addBannerCollection();
  //     }, 2000);
  //   }
  // });
  
  
  // async function addBannerCollection() {
  //   console.log("addBanner fue llamada")
  //   try {
  //     // Esperar a que los elementos estén disponibles
  //     const productCards = await waitForElements('ul.product-grid li.pd-card');
  //     const banners = document.querySelectorAll('.grid-banner').length;
  
  //     let totalList = productCards.length;
  //     let brCard = banners;
  
  //     console.log('Total de productos:', totalList);
  //     console.log('Total de banners:', brCard);
  
  //     if (brCard === 0 || totalList <= 3) {
  //       console.log('Hay menos o igual a 3 productos');
  //       const newItem = document.createElement('li');
  //       newItem.className = 'grid__item grid-banner';
  //       newItem.innerHTML = window.card_1;
  //       document.querySelector('ul.product-grid').appendChild(newItem);
  //     } else if (totalList > 3 && totalList < 9) {
  //       console.log('Hay más de 3 y menos de 9 productos');
  //       let randomNumber1 = getRandomNumber(2, 5);
  //       const newItemCard1 = document.createElement('li');
  //       newItemCard1.className = 'grid__item grid-banner';
  //       newItemCard1.innerHTML = window.card_1;
  
  //       const randomItem1 = document.querySelector(`ul.product-grid li:nth-child(${randomNumber1})`);
  //       if (randomItem1) {
  //         randomItem1.parentNode.insertBefore(newItemCard1, randomItem1.nextSibling);
  //       }
  //     } else if (totalList > 9) {
  //       console.log('Hay más de 9 productos');
  //       let randomNumber1 = getRandomNumber(2, 5);
  //       let randomNumber2 = getRandomNumber(9, 12);
  
  //       const newItemCard1 = document.createElement('li');
  //       newItemCard1.className = 'grid__item grid-banner';
  //       newItemCard1.innerHTML = window.card_1;
  
  //       const randomItem1 = document.querySelector(`ul.product-grid li:nth-child(${randomNumber1})`);
  //       if (randomItem1) {
  //         randomItem1.parentNode.insertBefore(newItemCard1, randomItem1.nextSibling);
  //       }
  
  //       const newItemCard2 = document.createElement('li');
  //       newItemCard2.className = 'grid__item grid-banner';
  //       newItemCard2.innerHTML = window.card_2;
  
  //       const randomItem2 = document.querySelector(`ul.product-grid li:nth-child(${randomNumber2})`);
  //       if (randomItem2) {
  //         randomItem2.parentNode.insertBefore(newItemCard2, randomItem2.nextSibling);
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Error en addBannerCollection:', error);
  //   }
  // }
  